import React from 'react';
import InvestmentRow from './InvestmentRow';
import EmptyState from '../common/EmptyState';

export default function InvestmentList({ investments }) {
  if (!investments || investments.length === 0) {
    return <EmptyState icon="💎" title="No investments yet" msg="Start your journey with a first stake." />;
  }
  return (
    <div>
      {[...investments].sort((a, b) => b.timestamp - a.timestamp).map(inv => (
        <InvestmentRow key={inv.index} inv={inv} />
      ))}
    </div>
  );
}
